import React from 'react';
import ChatMessage from '../../chat-message';
import CategorySelectionMessage from '../../CategorySelectionMessage';
import PipelineVisualization from '../../PipelineVisualization';
import Button from '../../../button/button';
import { getTemplatesForScreen } from '../../chat-templates';
import styles from './MessagesArea.scss';

const MessagesArea = ({
  messages,
  messagesEndRef,
  isLoading,
  error,
  pipelineActive,
  pipelineComplete,
  pipelineError,
  stages,
  currentStage,
  agentMessages,
  thinkingStreams = {},
  isCreatingConversation,
  isDeletingConversation,
  onTemplateClick,
  onToggleTemplates,
  isLightMode,
  currentScreen,
  onFeedback,
  onRegenerate,
  onCategorySelection,
}) => {
  // Filter templates based on current screen - show relevant templates first
  const templateQuestions = getTemplatesForScreen(currentScreen);

  // ✅ Find the index of the last AGENT message
  const lastAgentMessageIndex = messages.reduce((lastIdx, msg, idx) => {
    const isAgent = msg.type === 'AGENT' || msg.type === 'agent';
    return isAgent ? idx : lastIdx;
  }, -1);

  return (
    <div className={`${styles.messagesContainer} ${isLightMode ? styles.lightMode : ''}`}>
      {/* Welcome screen when no messages */}
      {messages.length === 0 && (
        <div className={styles.welcomeMessage}>
          <h4>Get Started</h4>
          <p>Choose a question template or ask your own</p>
          
          <div className={styles.welcomeTemplates}>
            {templateQuestions.slice(0, 6).map((template) => (
              <div
                key={template.id}
                className={styles.welcomeTemplateCard}
                onClick={() => onTemplateClick(template)}
              >
                <div className={styles.welcomeTemplateCategory}>{template.category}</div>
                <div className={styles.welcomeTemplateTitle}>{template.title}</div>
                <div className={styles.welcomeTemplateDesc}>{template.description}</div>
              </div>
            ))}
          </div>
          
          <div className={styles.welcomeFooter}>
            <Button
              onClick={onToggleTemplates}
              variant="text"
              text="View all templates →"
            />
          </div>
        </div>
      )}
      
      {/* Message list */}
      {messages.map((message, index) => {
        if (message.type === 'CATEGORY_SELECTION') {
          return (
            <CategorySelectionMessage
              key={message.id}
              message={message}
              isLightMode={isLightMode}
              onSubmit={onCategorySelection}
            />
          );
        }
        return (
          <ChatMessage
            key={message.id}
            message={message}
            isLightMode={isLightMode}
            onFeedback={onFeedback}
            onRegenerate={onRegenerate}
            isLoading={isLoading}
            isLastAgentMessage={index === lastAgentMessageIndex}
          />
        );
      })}
      
      {/* Pipeline Visualization - active state shows streaming, complete state shows collapsed toggle */}
      {(pipelineActive || pipelineComplete) && (
        <PipelineVisualization
          stages={stages}
          isActive={pipelineActive && !pipelineComplete}
          isComplete={pipelineComplete}
          thinkingStreams={thinkingStreams}
          error={pipelineError}
          isLightMode={isLightMode}
        />
      )}
      


      {/* Error message */}
      {error && (
        <div className={styles.errorMessage}>
          <span>❌ {error}</span>
        </div>
      )}

      {/* Creating conversation indicator */}
      {isCreatingConversation && (
        <div className={styles.loadingMessage}>
          <span>🆕 Creating new conversation...</span>
        </div>
      )}

      {/* Deleting conversation indicator */}
      {isDeletingConversation && (
        <div className={styles.loadingMessage}>
          <span>🗑️ Deleting conversation...</span>
        </div>
      )}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessagesArea;

